<!-- components/dashboard/cards/OrdemMiniCard.vue -->
<template>
  <div class="ordem-mini-card" :class="{ 'urgente': ordem.urgente, 'atrasada': ordem.atrasada }">
    <div class="ordem-header">
      <div class="ordem-id">
        <strong>##SAP {{ ordem.id_ordem }} ##ID {{ ordem.id }} ##Pedido {{ ordem.id_pedido }} </strong>
        <span v-if="ordem.urgente" class="badge urgente">⚡</span>
        <span v-if="ordem.atrasada" class="badge atrasada">🚨</span>
      </div>
      <div class="drag-handle">⋮⋮</div>
    </div>
    
    <div class="ordem-info">
      <div class="cliente">{{ ordem.cliente }}</div>
      <div class="produto">{{ ordem.produto }}</div>
      
      <div class="detalhes">
        <span class="quantidade">{{ ordem.quantidadeTotal }} un</span>
        <span class="prazo">{{ ordem.prazoEntregaFormatado }}</span>
      </div>
      
      <div v-if="ordem.proximoSetor" class="proximo-setor">
        <span class="setor-nome">{{ ordem.proximoSetor.nome }}</span>
        <span class="tempo">{{ ordem.tempoEstimado?.formatado }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrdemMiniCard',
  props: {
    ordem: {
      type: Object,
      required: true
    },
    draggable: {
      type: Boolean,
      default: true
    }
  },
  emits: ['selecionar']
}
</script>

<style scoped>
.ordem-mini-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
  cursor: grab;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.ordem-mini-card:hover {
  border-color: #3498db;
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
  transform: translateY(-2px);
}

.ordem-mini-card.urgente {
  border-left: 4px solid #e74c3c;
}

.ordem-mini-card.atrasada {
  border-left: 4px solid #f39c12;
}

.ordem-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.ordem-id {
  display: flex;
  align-items: center;
  gap: 6px;
}

.ordem-id strong {
  color: #2c3e50;
  font-size: 14px;
}

.badge {
  font-size: 10px;
  padding: 2px 4px;
  border-radius: 8px;
  color: white;
}

.badge.urgente {
  background: #e74c3c;
}

.badge.atrasada {
  background: #f39c12;
}

.drag-handle {
  color: #bdc3c7;
  font-size: 12px;
  cursor: grab;
}

.ordem-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cliente {
  font-weight: 500;
  color: #2c3e50;
  font-size: 13px;
}

.produto {
  color: #7f8c8d;
  font-size: 12px;
}

.detalhes {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #95a5a6;
  margin-top: 4px;
}

.proximo-setor {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  padding: 4px 8px;
  border-radius: 4px;
  margin-top: 6px;
}

.setor-nome {
  font-size: 10px;
  color: #3498db;
  font-weight: 500;
}

.tempo {
  font-size: 10px;
  color: #7f8c8d;
}
</style>